/* eslint-disable no-unused-vars */
/* eslint-disable no-alert */
/* eslint-disable react/self-closing-comp */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useRef, useState } from "react";
import "./UpdateSession.css";
import TextField from "@mui/material/TextField";
import { LocalizationProvider, TimePicker } from "@mui/lab";
import { cloneDeep } from "lodash";
import moment from "moment";
import DateAdapter from "@mui/lab/AdapterDateFns";

import { Button, Checkbox, FormControl, IconButton } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useDispatch, useSelector } from "react-redux";
import IndividualTask from "../IndividualTask/IndividualTask";
import Locale from "../../../locales";
import { updateSession } from "../../../redux/actions";
import { sessionNames } from "../../../constants/sessionNames";
import { checkForSessionConflicts } from "../../../shared/checkForSessionConflicts";
import {
  deleteSession,
  teacherRequestFail,
} from "../../../redux/actions/teacher";
import DeleteDialog from "../../DeleteDialog/DeleteDialog";
import {
  EVENT_DESCRIPTION,
  EVENT_TITLE,
} from "../../../constants/textFieldMaxLengths";
import { AVOID_SPECIAL_CHARACTER } from "../../../constants/Regex";
import { sanitizeInputObject } from "../../../utils/sanitize";

const UpdateSession = () => {
  const currentUser = useSelector((state) => state.authReducer.currentUser);
  const currentStudent = useSelector(
    (state) => state.teacherReducer.currentStudent,
  );
  const sessions = useSelector((state) => state.teacherReducer.sessions);
  const loading = useSelector((state) => state.teacherReducer.loading);
  const [title, setTitle] = useState("");
  const [startDateTime, setStartDateTime] = useState(new Date());
  const [sessionDuration, setSessionDuration] = useState(0);
  const [singleTaskSession, setSingleTaskSession] = useState(true);
  const [session, setSession] = useState("");
  const [sessionIndex, setSessionIndex] = useState(0);
  const [deletePopup, setDeletePopup] = useState(false);
  const [currentSessionId, setCurrentSessionId] = useState("");
  const dispatch = useDispatch();

  const DEFAULT_SESSIONS = [
    {
      title: "Session 1",
      sessionDuration: 0,
      sessionId: "",
      sessionEvents: [
        {
          orderIndex: 0,
          title: "",
          description: "",
          duration: 0,
          teacherId: currentUser,
          studentId: currentStudent,
        },
      ],
    },
    {
      title: "Session 2",
      sessionDuration: 0,
      sessionId: "",
      sessionEvents: [
        {
          orderIndex: 0,
          title: "",
          description: "",
          duration: 0,
          teacherId: currentUser,
          studentId: currentStudent,
        },
      ],
    },
    {
      title: "Session 3",
      sessionDuration: 0,
      sessionId: "",
      sessionEvents: [
        {
          orderIndex: 0,
          title: "",
          description: "",
          duration: 0,
          teacherId: currentUser,
          studentId: currentStudent,
        },
      ],
    },
  ];
  const [defaultSessions, setDefaultSessions] = useState(DEFAULT_SESSIONS);
  const [tasks, setTasks] = useState([
    {
      title: "",
      description: "",
      duration: 0,
      teacherId: currentUser,
      studentId: currentStudent,
    },
  ]);

  useEffect(() => {
    let totalDuration = 0;
    tasks.forEach((task) => {
      totalDuration += parseInt(task.duration, 10);
    });
    setSessionDuration(totalDuration);
  }, [tasks.length]);

  const reset = () => {
    setSession("");
    setCurrentSessionId("");
    setSessionDuration(0);
    setSingleTaskSession(true);
    setTasks([
      {
        title: "",
        description: "",
        duration: 0,
        teacherId: currentUser,
        studentId: currentStudent,
      },
    ]);
  };

  useEffect(() => {
    const updatedDefaultSessions = cloneDeep(DEFAULT_SESSIONS);

    sessions.forEach((ele) => {
      const sessionTitle = ele.title;
      switch (sessionTitle) {
        case sessionNames.SESSION1: {
          updatedDefaultSessions[0] = ele;
          break;
        }
        case sessionNames.SESSION2: {
          updatedDefaultSessions[1] = ele;
          break;
        }
        case sessionNames.SESSION3: {
          updatedDefaultSessions[2] = ele;
          break;
        }
        default:
          break;
      }
    });
    setDefaultSessions(updatedDefaultSessions);
    reset();
  }, [sessions]);

  const updateSessionDuration = () => {
    let totalDuration = 0;
    tasks.forEach((task) => {
      totalDuration += parseInt(task.duration, 10);
    });
    setSessionDuration(totalDuration);
  };

  useEffect(() => {
    const selectedSession = defaultSessions.find(
      (ele) => ele.title === session,
    );
    if (selectedSession) {
      const {
        title: fetchedTitle,
        startDate,
        startTime,
        sessionDuration: fetchedSessionDuration,
        sessionEvents: fetchedTasks,
        sessionId,
      } = selectedSession;
      const fetchedDateTime =
        startDate && startTime
          ? new Date(`${startDate} ${startTime}`)
          : new Date();
      const fetchedCheckboxValue = fetchedTasks.length === 1;
      setStartDateTime(fetchedDateTime);
      setCurrentSessionId(sessionId);
      setTitle(fetchedTitle);
      setSessionDuration(
        typeof fetchedSessionDuration === "number" ? fetchedSessionDuration : 0,
      );
      if (fetchedTasks) {
        setTasks(cloneDeep(fetchedTasks));
      }
      setSingleTaskSession(fetchedCheckboxValue);
    }
  }, [session]);

  const sessionStartTimeChange = (event) => {
    if (session === "") return;
    setStartDateTime(event);
  };

  const singleTaskCheckboxHandler = (event) => {
    if (session === "") return;
    setSingleTaskSession(event.target.checked);
    if (event.target.checked === true) {
      const updatedTasks = [tasks[0]];
      setTasks(updatedTasks);
      setSessionDuration(parseInt(tasks[0].duration, 10));
    }
  };

  const addTaskButtonClick = () => {
    if (session === "") return;
    const updatedTasks = tasks.concat({
      title: "",
      description: "",
      duration: 0,
      teacherId: currentUser,
      studentId: currentStudent,
    });
    setTasks(updatedTasks);
  };

  const updateTaskHandler = (name, value, index) => {
    if (session === "") return;
    const updatedTasks = [...tasks];
    const changedTask = updatedTasks[index];
    changedTask[name] = value;
    updatedTasks[index] = changedTask;
    setTasks(updatedTasks);
    updateSessionDuration();
  };

  const saveSessionHandler = (event) => {
    event.preventDefault();
    if (session === "") return;
    const startDate = moment(startDateTime).format("YYYY-MM-DD");
    const startTime = moment(startDateTime).format("HH:mm:ss");

    const tasksWithOrderIndex = [];

    for (let i = 0; i < tasks.length; i += 1) {
      const task = sanitizeInputObject(tasks[i]);

      if (!task.title) {
        dispatch(
          teacherRequestFail(
            Locale.t("is_required").replace("{{prop}}", "Title"),
          ),
        );
        return;
      }

      if (!task.description) {
        dispatch(
          teacherRequestFail(
            Locale.t("is_required").replace("{{prop}}", "Description"),
          ),
        );
        return;
      }

      if (task.title.length > EVENT_TITLE) {
        dispatch(
          teacherRequestFail(
            Locale.t("event_title_should_be_less").replace(
              "{{eventTitle}}",
              EVENT_TITLE,
            ),
          ),
        );
        return;
      }

      if (!AVOID_SPECIAL_CHARACTER.test(task.title)) {
        dispatch(
          teacherRequestFail(
            Locale.t("event_title_should_not_contain_special_character"),
          ),
        );
        return;
      }

      if (task.description.length > EVENT_DESCRIPTION) {
        dispatch(
          teacherRequestFail(
            Locale.t("event_description_should_be_less").replace(
              "{{eventDescription}}",
              EVENT_DESCRIPTION,
            ),
          ),
        );
        return;
      }

      task.orderIndex = i;
      delete task.sessionId;
      tasksWithOrderIndex.push(task);
    }

    const conflictingSession = checkForSessionConflicts(
      sessions,
      startTime,
      currentSessionId,
      sessionDuration,
      session,
    );

    if (sessionDuration === 0) {
      alert(Locale.t("duration_cannot_be_zero"));
      return;
    }

    if (conflictingSession.isEarly) {
      alert(
        Locale.t("session_should_come_after")
          .replace("{{sessionName}}", session)
          .replace("{{conflictingSession}}", conflictingSession.isEarly),
      );
      return;
    }

    if (conflictingSession.title) {
      // eslint-disable-next-line no-unused-expressions

      // one minute alert
      if (conflictingSession.diff > 0 && conflictingSession.diff <= 60) {
        alert(Locale.t("min_between_session"));
        return;
      }

      alert(
        Locale.t("session_time_conflicting_with_session").replace(
          "{{sessionName}}",
          conflictingSession.title,
        ),
      );
      return;
    }

    if (conflictingSession.isLate) {
      alert(
        Locale.t("session_should_come_before")
          .replace("{{sessionName}}", session)
          .replace("{{conflictingSession}}", conflictingSession.isLate),
      );
      return;
    }

    if (conflictingSession.reachedEnd) {
      alert(Locale.t("reached_the_end"));
      return;
    }

    const formData = {
      startDate,
      startTime,
      previousSessionId: currentSessionId,
      studentId: currentStudent,
      title,
      sessionDuration,
      startDateTimeUTC: startDateTime.toISOString(),
      sessionEvents: tasksWithOrderIndex,
    };

    reset();
    dispatch(updateSession(currentSessionId, currentStudent, formData));
  };

  const deleteIndividualTaskHandler = (index) => {
    const updatedTasks = cloneDeep(tasks);
    updatedTasks.splice(index, 1);
    setTasks(updatedTasks);
    // updateSessionDuration();
  };

  const deleteCurrentSession = () => {
    dispatch(
      deleteSession({ sessionId: currentSessionId, studentId: currentStudent }),
    );
    setDeletePopup(false);
  };

  const selectSession = (ses, index) => {
    setSession(ses.title);
    setSessionIndex(index);
  };

  const disableSessionButton = (index) => {
    if (index === 0) return false;
    for (let i = 0; i < index; i += 1) {
      if (!defaultSessions[i].sessionId) {
        return true;
      }
    }

    return false;
  };

  const disabledDeleteButton = (index) => {
    if (index === defaultSessions.length - 1) return false;

    for (let i = defaultSessions.length - 2; i >= index; i -= 1) {
      if (defaultSessions[i + 1].sessionId) {
        return true;
      }
    }
    return false;
  };

  return (
    <>
      <DeleteDialog
        open={deletePopup}
        confirmDelete={deleteCurrentSession}
        message="are_you_sure_you_want_to_delete_this_session"
        handleClose={() => setDeletePopup(false)}
      />
      <form onSubmit={saveSessionHandler}>
        <div className="edit-session-details-container">
          <div className="edit-select-session-container">
            <FormControl disabled={loading} fullWidth>
              {Locale.t("select_session_to_update")}
              <div className="session-btn-container">
                {defaultSessions.map((ses, index) => (
                  <Button
                    key={index}
                    disabled={disableSessionButton(index)}
                    onClick={() => selectSession(ses, index)}
                    variant={ses.title === session ? "contained" : "outlined"}
                    color="success">
                    {ses.title}
                  </Button>
                ))}
              </div>
            </FormControl>
          </div>
          {session !== "" ? (
            <div className="edit-single-task-container">
              <div className="edit-single-task-checkbox">
                <p>{Locale.t("single_time_block")}</p>
                <Checkbox
                  size="medium"
                  checked={singleTaskSession}
                  onChange={singleTaskCheckboxHandler}
                />
              </div>
              {defaultSessions[sessionIndex].sessionId && (
                <Button
                  disabled={disabledDeleteButton(sessionIndex)}
                  onClick={() => setDeletePopup(true)}
                  variant="contained"
                  color="error">
                  Delete Session
                </Button>
              )}
            </div>
          ) : (
            <div className="edit-single-task-checkbox"></div>
          )}
          <div>
            {session !== "" ? (
              <div className="edit-session-startTime-container">
                <LocalizationProvider dateAdapter={DateAdapter}>
                  <TimePicker
                    label={Locale.t("start_time")}
                    value={startDateTime}
                    onChange={sessionStartTimeChange}
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        {...params}
                        helperText={Locale.t("start_time_is_required")}
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
            ) : (
              <div className="edit-session-startTime-container"></div>
            )}
            {session !== "" ? (
              <div className="edit-session-duration-container">
                <div className="session-duration-container">
                  <p>{Locale.t("session_duration")}</p>
                  <p>{`${sessionDuration || 0} mins`}</p>
                </div>
              </div>
            ) : (
              <div className="edit-session-duration-container"></div>
            )}
          </div>
        </div>
        <div className="edit-tasks-container">
          {session !== "" &&
            tasks.map((task, index) => (
              <IndividualTask
                key={index}
                singleTaskSession={singleTaskSession}
                updateTaskHandler={updateTaskHandler}
                deleteIndividualTask={deleteIndividualTaskHandler}
                task={task}
                index={index}
                updateSessionDuration={updateSessionDuration}
              />
            ))}
          {!singleTaskSession && (
            <IconButton
              disabled={loading}
              onClick={addTaskButtonClick}
              color="secondary"
              size="large"
              aria-label={Locale.t("add")}>
              <AddCircleIcon />
            </IconButton>
          )}
        </div>
        <div className="edit-save-session-button-container">
          <Button
            disabled={loading}
            type="submit"
            color="warning"
            variant="contained">
            {Locale.t("update_session")}
          </Button>
        </div>
      </form>
    </>
  );
};

export default UpdateSession;
